export const DROPDOWN_ITEMS_LIMIT = 1000;
export const INFINITY_LIST_ITEMS = 50;
export const SEARCH_PARAM_NAME = 'search';
export const QUERY_MAX_LENGTH = 1900;

export const FILTER_STYLES = {
  container: 'flex gap-4 flex-wrap items-center',
  search: 'grow basis-0 min-w-[206px]',
  select: 'grow basis-0 min-w-[200px]',
  oneOfThreeSelect: 'screen-md:basis-[31.8%]',
  campaignsOutOfGroups: 'grow basis-0 min-w-[280px]',
  quickFilter: 'grow basis-0 min-w-[310px]',
  datePicker: 'grow basis-0 min-w-[256px]',
};
